/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest } from 'redux-saga/effects';
import { passkeyDeregister } from '../api';
import {
  passkeyDeregisterFailed,
  passkeyDeregisterOtpRequired,
  passkeyDeregisterRequest,
  passkeyDeregisterSuccess,
} from '../reducer/passkeyDeregisterSlice';
import { getPasskeyOtpStepUp } from '../utils/passkeyList';

export function* passkeyDeregisterSaga(
  action: any
): Generator<any, void, unknown> {
  const { apiName, data } = action.payload;
  try {
    const response: any = yield call(passkeyDeregister, apiName, data);
    const otpStepUp = getPasskeyOtpStepUp(response);
    if (otpStepUp.required && otpStepUp.passkeyToken) {
      yield put(
        passkeyDeregisterOtpRequired({ passkeyToken: otpStepUp.passkeyToken })
      );
      return;
    }

    const isSuccessStatus =
      response?.status === 200 || response?.status === '200';

    if (isSuccessStatus) {
      yield put(passkeyDeregisterSuccess(response));
    } else {
      const { status, detail, errorCode, body } = response ?? {};
      yield put(
        passkeyDeregisterFailed({
          statusCode: status ?? '500',
          error: {
            errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
            msg: detail ?? body ?? 'An unknown error occurred.',
            statusCode: status ?? '500',
          },
        })
      );
    }
  } catch (error: any) {
    const otpStepUp = getPasskeyOtpStepUp(error);
    if (otpStepUp.required && otpStepUp.passkeyToken) {
      yield put(
        passkeyDeregisterOtpRequired({ passkeyToken: otpStepUp.passkeyToken })
      );
      return;
    }
    const {
      status = '500',
      errorCode = 'UNKNOWN_ERROR',
      detail = 'An unknown error occurred.',
    } = error?.data ?? error ?? {};
    yield put(
      passkeyDeregisterFailed({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}

export function* watchPasskeyDeregisterSaga() {
  yield takeLatest(passkeyDeregisterRequest.type, passkeyDeregisterSaga);
}
